module.exports = new __parcel__URL__("red_heart.8ad61bd1.svg").toString();